import {remCalc} from '../../_utils'

/**
 * the breadcrumb style
 */
export default {
    baseStyle: {
        container: {
            color: 'foreground.neutral.subtle',
            textStyle: 'body-small',
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
            // flexWrap: {base: 'wrap', sm: 'wrap', md: 'nowrap', lg: 'nowrap'},
            // whiteSpace: {base: 'normal', sm: 'normal', md: 'nowrap', lg: 'nowrap'},
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'left',
            // wordBreak: {base: 'break-word', sm: 'break-word', md: 'normal', lg: 'normal'},
        },
        price: {
            //textDecoration: 'line-through',
            color: 'foreground.neutral.subtle',
            fontWeight: 'medium',
        },
        label: {
            color: 'foreground.neutral.subtle',
            fontWeight: 'medium',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'clip',
            maxWidth: remCalc(180),
        },
    },
    variants: {
        sticky: {
            container: {
                textStyle: ['body-xsmall'],
                color: 'foreground.neutral.subtle',
                whiteSpace: 'nowrap',
                flexDir: 'row',
                gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.lg', 'xxxsmall.xl'],
            },
            price: {
                fontWeight: 'medium',
            },
            label: {
                fontWeight: 'normal',
            },
        },
        recommended: {
            container: {
                textStyle: ['body-xsmall'],
                whiteSpace: 'nowrap',
                flexDir: 'row',
            },
            price: {
                fontWeight: 'medium',
            },
        },
        productUpgrade: {
            container: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
                flexDir: 'row',
                gap: remCalc(4),
                alignItems: 'center',
            },
            price: {
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
            },
            label: {
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
                maxWidth: 'none',
                whiteSpace: 'normal',
            },
        },
        // wraps the label/price onto new lines instead of truncating, sized to the parent's width (product-compare tile)
        compare: {
            container: {
                flexWrap: 'wrap',
                whiteSpace: 'normal',
                width: 'full',
            },
            label: {
                whiteSpace: 'normal',
                overflow: 'visible',
                textOverflow: 'clip',
                maxWidth: 'full',
            },
            price: {
                whiteSpace: 'normal',
            },
        },
        productList: {
            label: {
                maxWidth: {
                    base: remCalc(180),
                    sm: remCalc(180),
                    md: 'unset',
                    lg: 'unset',
                },
            },
        },
        'cart-product-item': {
            label: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            price: {
                textStyle: 'body-xsmall',
            },
        },
    },
}
